module.exports = __webpack_public_path__ + "img/deficit_icon.8a5aebaf.png";